import { Organization } from "../organization/organizationModel";
import { User } from "../user/userModel";

/**
 * Lifecycle order: also drives the status filter options and the status column
 * sorting, so both stay consistent wherever sponsorships are listed.
 */
export const PREMIUM_SPONSORSHIP_STATUSES = [
  "invited",
  "accepted",
  "declined",
  "revoked",
] as const;

export type PremiumSponsorshipStatus =
  (typeof PREMIUM_SPONSORSHIP_STATUSES)[number];

export const PREMIUM_SPONSORSHIP_STATUS_LABEL_KEYS = {
  invited: "organization:premium-sponsorship.status.INVITED",
  accepted: "organization:premium-sponsorship.status.ACCEPTED",
  declined: "organization:premium-sponsorship.status.DECLINED",
  revoked: "organization:premium-sponsorship.status.REVOKED",
} as const;

export interface PremiumSponsorship {
  id: number;
  organizationId: Organization["id"];
  organization?: { legalName: string };
  email: string;
  /**
   * Present when fetched via the "mine" endpoint (own data) or the
   * organization listing (the organization issued the invitation).
   */
  token?: string;
  userId: User["id"] | null;
  status: PremiumSponsorshipStatus;
  premiumGranted: boolean | null;
  dataAccessConsent: boolean | null;
  invitedAt: string;
  respondedAt: string | null;
  revokedAt: string | null;
}

export interface PremiumSponsorshipPreview {
  status: PremiumSponsorshipStatus;
  email: string;
  organizationName: string | null;
  hasAccount: boolean;
}

export interface InvitePremiumSponsorshipsResult {
  created: PremiumSponsorship[];
  skipped: string[];
}
